/**
 * Where selecting a card goes.
 *
 * One function rather than the same conditional at four call sites, because the rule is a
 * product decision and it changed once already: cards used to go straight to `/watch`,
 * which turned browsing into playback with no way to look before committing.
 *
 * The three cases are genuinely different, not variations of one:
 *
 *   live     straight to the picture — a channel has no synopsis to read and no position
 *            to resume, and it is already running whether or not anyone is watching.
 *   series   the season and episode list, which is the only route into an episode.
 *   movie    the detail screen: poster, synopsis, running time, and a resume button when
 *            there is something to resume.
 */
import type { CatalogItemDto } from '@filmodasi/shared';

export function detailPath(item: Pick<CatalogItemDto, 'id' | 'type'>): string {
  if (item.type === 'live') return `/watch/${item.id}`;
  if (item.type === 'series') return `/series/${item.id}`;
  return `/item/${item.id}`;
}
